import script from "./CardAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./CardAdmin.vue?vue&type=script&setup=true&lang=js"

import "./CardAdmin.vue?vue&type=style&index=0&id=0335be6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0335be6a"]])

export default __exports__